import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  images,
} from '../../../../assets/image';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';

const PointsWidget: React.FC<WidgetProps> = (props: WidgetProps) => {

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const paramLang = queryParams.get('lang');

  const {
    widgetParams,
    defaultPaddings,
  } = props;

  return (
    <div style={defaultPaddings} className={styles.pointsCard}>
      <h4>
        {
          paramLang === 'en' ? 'Remaining points' : 'النقاط المتاحة'
        }
      </h4>
      <div>
        <div className={styles.points}>
          <span>{images.goldenStar}</span>
          <h5>20K</h5>
          <span>{paramLang === 'en' ? 'Points' : 'نقطة'}</span>
        </div>
        <h6>{paramLang === 'en' ? 'every 100 points equal to 1 EGP' : 'كل 100 نقطة تساوي جنيه'}</h6>
      </div>
      <div className={styles.button}>
        <h5>{paramLang === 'en' ? 'Account details' : 'تفاصيل الحساب'}</h5>
      </div>
    </div>
  );
};

export default PointsWidget;
